import axios from 'axios';
import {apiConnector} from './apiconnector'; // Assuming you have a custom API connector
const BASE_URL = process.env.REACT_APP_API_URL; 
const API_URL= `${BASE_URL}/areas`; 
export const getAreas = async (token) => {
const response = await apiConnector("GET", API_URL,null ,
        { Authorization: `Bearer ${token}` }
      );
//   const response = await axios.get(API_URL, {
//     headers: { Authorization: `Bearer ${token}` }
//   });
  return response.data;
};

export const createArea = async (area,token) => {
    const response = await apiConnector("POST", API_URL,area ,
        { Authorization: `Bearer ${token}` }
      );
//   const response = await axios.post(API_URL, area, {
//     headers: { Authorization: `Bearer ${token}` }
//   });
  return response.data;
};

export const deleteArea = async (id,token) => {
    const response = await apiConnector("DELETE", `${API_URL}/${id}`,null ,
        { Authorization: `Bearer ${token}` }
      );
//   const response = await axios.delete(`${API_URL}/${id}`, {
//     headers: { Authorization: `Bearer ${token}` }
//   });
  return response.data;
};
